var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-menu-item',{attrs:{"route":"","index":"/users"}},[_c('template',{slot:"title"},[_c('router-link',{staticClass:"sub-menu-link",attrs:{"to":"/users"}},[_c('div',{staticClass:"img-wrapper"},[_c('img',{attrs:{"src":require("@src/assets/sidebar/users.svg")}})]),_c('span',[_vm._v(" "+_vm._s(_vm.$t('sidebar.users')))])])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }